import classNames from "classnames";
import React from "react";

import { InfoTooltip } from "../info-tooltip";
import {
  FIELD_LABEL_COLOR_CLASSES,
  FIELD_LABEL_SIZE_CLASSES,
} from "./FieldLabel.constants";
import { FieldLabelProps } from "./FieldLabel.types";

export const FieldLabel: React.FC<FieldLabelProps> = ({
  label,
  required,
  infoTooltip,
  tooltipId,
  size = "md",
  color = "primary",
  htmlFor,
  className,
}) => {
  const resolvedTooltipId =
    tooltipId || `field-label-${label.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <div
      className={classNames(
        "mb-2 flex items-center gap-1 font-Manrope font-medium",
        FIELD_LABEL_SIZE_CLASSES[size],
        FIELD_LABEL_COLOR_CLASSES[color],
        className,
      )}>
      <label htmlFor={htmlFor}>
        {label}
        {required && <span className={"text-[#DC2626]"}>*</span>}
      </label>
      {infoTooltip && (
        <InfoTooltip
          id={resolvedTooltipId}
          content={infoTooltip}
          place={"right"}
          size={18}
          tooltipClassName={"!max-w-[220px]"}
        />
      )}
    </div>
  );
};
